var React = require('react');

function Signout (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 11.66V21C18 21.55 17.55 22 17 22H3C2.45 22 2 21.55 2 21V7C2 6.45 2.45 6 3 6H12.34","fill":"white","fillOpacity":"0.3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.0004 1.3999C15.669 1.3999 15.4004 1.66853 15.4004 1.9999C15.4004 2.33127 15.669 2.5999 16.0004 2.5999H20.5519L9.57613 13.5756C9.34181 13.81 9.34181 14.1899 9.57613 14.4242C9.81044 14.6585 10.1903 14.6585 10.4247 14.4242L21.4004 3.44843V7.9999C21.4004 8.33127 21.669 8.5999 22.0004 8.5999C22.3318 8.5999 22.6004 8.33127 22.6004 7.9999V1.9999C22.6004 1.66853 22.3318 1.3999 22.0004 1.3999H16.0004Z","fill":"white","fillOpacity":"0.6","key":1})]);
}

Signout.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Signout;

Signout.default = Signout;
